import React, {useState} from "react";
import PropTypes from "prop-types";
import {ReactComponent as CompanyLogo} from "../../assets/logo.svg";
import styled from "@emotion/styled";
import HexagonButton from "../common/HexagonButton";

import {ReactComponent as Launch} from "../../assets/Launch.svg";
import {ReactComponent as User} from "../../assets/User.svg";
import {ReactComponent as Notification} from "../../assets/Notification.svg";
import UserInfoPopOver from "./UserInfoPopOver";
import TopDownTransition from "../animations/TopDownTransition";
import LinearLoadingIndicator from "../common/LinearLoadingIndicator";
import {connect} from "react-redux";
import {setPanel} from "../../redux/actions/panelActions";
import UserRole from "../common/UserRole";
import Badge from "@material-ui/core/Badge";

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--header-height);
  padding: 0 var(--space-l);

  //@supports (display: grid) {
  //  display: flex;
  //  grid-template-columns: var(--grid-layout-wide);
  //  align-items: center;
  //  grid-auto-flow: column;
  //}
`;

const HeaderActionsWrapper = styled.div`
    width: fit-content;
    display: grid;
    grid-column-gap: 8px ;
    grid-auto-flow: column;
    
    align-items: center;
`;

const CompanyLogoWrapper = styled.div`
  display: flex;  
  flex-direction: row;
  align-items: center;
`;

const CompanyNameWrapper = styled.div`
    /* text-xl/Medium */
    
    font-family: Metropolis,serif;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */
    
    margin-left: 26px;
    
    color: var(--company);
`;

function HeaderBlock(props) {

    const {
        logo,
        user,
        auth,
        isLoading,
        setPanel,
        panel,
        notificationsCount
    } = props;

    const [userInfoPopOverAnchor, setAnchor] = useState();
    let userBtnRef = React.createRef();

    const handleOnLaunchButtonClick = () => {

    };

    const handleOnUserButtonClick = (e) => {
        // if (e) setAnchor(e.currentTarget);
        setAnchor(userBtnRef.current);
        console.log(userBtnRef);
    };


    const onUserPopoverClose = () => {
        setAnchor(null);
    };

    const handleOnNotifClick = () => {
        setPanel({notifications: !panel.notifications})
    };

    return (
        <TopDownTransition>
            <Header className={"header"} key="header-component">
                <CompanyLogoWrapper>
                    <CompanyLogo/>
                    <CompanyNameWrapper>
                        Smart Payment Plan
                    </CompanyNameWrapper>
                </CompanyLogoWrapper>

                <HeaderActionsWrapper>

                    <div>
                        { (user) ? `${user.firstName || ''} ${user.lastName || ''}` : "" }
                    </div>

                    <UserRole role={auth.role}  />



                    {/*<HexagonButton Icon={Launch} onClick={handleOnLaunchButtonClick}/>*/}

                    <div ref={userBtnRef}>
                        <HexagonButton Icon={User} onClick={handleOnUserButtonClick}/>
                    </div>

                    <Badge
                        badgeContent={notificationsCount}
                        color="secondary"
                        overlap="circle"
                        max={10}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <HexagonButton Icon={Notification} onClick={handleOnNotifClick}/>
                    </Badge>

                    <UserInfoPopOver anchorEl={userInfoPopOverAnchor} onClose={onUserPopoverClose}/>
                </HeaderActionsWrapper>
            </Header>

            {isLoading && <LinearLoadingIndicator key="Loading-Indicator"/>}
        </TopDownTransition>
    )
}

HeaderBlock.propTypes = {
    logo: PropTypes.any,
    isLoading: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
    let notificationsCount = state.alerts.reduce((accumulator, currentValue) =>  (!currentValue.seen) ? accumulator+1 : accumulator, 0);
    return {
        isLoading: state.apiCallsInProgressCount > 0,
        panel: state.panel,
        user: state.user,
        auth: state.auth,
        notificationsCount
    }
}

const mapDispatchToProps = {
    setPanel
};


export default connect(mapStateToProps, mapDispatchToProps)(HeaderBlock)
